import { useCallback } from "react";
import { useFieldArray } from "react-hook-form";
import { v4 as uuidv4 } from "uuid";
import { availableQuestionTypes } from "../support/availableQuestionTypes";

export const useQuestions = (control: any, sectionIndex: number, getValues: any) => {
    const { fields, append, remove, insert, move } = useFieldArray({
        control,
        name: `sections.${sectionIndex}.questions`
    });

    const add = useCallback(() => {
        append({
            id: uuidv4(),
            name: "",
            type: availableQuestionTypes[0],
            description: "",
            isRequired: true,
            isHiddenFromReviwers: false
        });
    }, [append]);

    const duplicate = useCallback((index: number) => {
        const current = getValues(`sections.${sectionIndex}.questions.${index}`);
        if (current) {
            insert(index + 1, current);
        }
    }, [getValues, insert, sectionIndex]);

    return {
        fields,
        add,
        remove,
        duplicate,
        move
    };
}
